export const DRIVER_STATUS = {
  INCOMPLETE_REGISTRATION: 'cadastro_incompleto',
  IN_QUEUE: 'na_fila',
  LICENSED: 'habilitado'
};

export const WAITING_STATUS = [DRIVER_STATUS.IN_QUEUE, DRIVER_STATUS.LICENSED];
